var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ((_obj = { notification: true, show: _vm.show }),
      (_obj[_vm.type] = _vm.type),
      _obj)
    },
    [
      _c("div", { staticClass: "badge" }, [
        _vm._v("\n\t\t" + _vm._s(_vm.type) + "\n\t")
      ]),
      _vm._v(" "),
      _c("p", { domProps: { innerHTML: _vm._s(_vm.message) } }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "close",
          on: {
            click: function($event) {
              _vm.$eventHub.$emit("notification", { show: false })
            }
          }
        },
        [_c("i", { staticClass: "ion-close" })]
      )
    ]
  )
  var _obj
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38e6542f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38e6542f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notification/Notification.vue
// module id = null
// module chunks = 